(function () {
  'use strict';

  let ioObserver = null;
  let activeSentinel = null;

  function setup() {
    const sentinel = document.getElementById('infinite-scroll-trigger');

    if (!sentinel) return;
    if (sentinel === activeSentinel) return;

    if (ioObserver) { ioObserver.disconnect(); ioObserver = null; }
    activeSentinel = sentinel;

    if (!sentinel.dataset.nextUrl) return;

    ioObserver = new IntersectionObserver(onIntersect, { rootMargin: '400px' });
    ioObserver.observe(sentinel);
  }

  async function onIntersect([entry]) {
    if (!entry.isIntersecting) return;

    const sentinel = entry.target;
    const grid = document.getElementById('CollectionLoop');
    const url = sentinel.dataset.nextUrl;

    if (!url || !grid) return;

    ioObserver.disconnect();

    try {
      const resp = await fetch(url);
      const html = await resp.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.getElementById('CollectionLoop');
      if (newGrid) {
        [...newGrid.children].forEach(el => grid.appendChild(el));
      }

      const nextLink = doc.querySelector('.pagination-custom__next');
      sentinel.dataset.nextUrl = nextLink ? nextLink.href : '';

      if (nextLink) ioObserver.observe(sentinel);

    } catch (e) {
      console.error('[InfiniteScroll]', e);
      if (ioObserver) ioObserver.observe(sentinel);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  let domTimer;
  new MutationObserver(() => {
    clearTimeout(domTimer);
    domTimer = setTimeout(setup, 50);
  }).observe(document.body, { childList: true, subtree: true });

})();